import React from 'react';
import 'components/ui/form/color_selector.scss';
import InputGroup from 'components/ui/form/input_group';
import Label from 'components/ui/form/label';
import FormGroup from 'components/ui/form/form_group';

const availableColors = [
  'primary',
  'secondary',
  'success',
  'danger',
  'warning',
  'info',
  'light',
  'dark',

];

const FormColorSelector = ({ input: { value, onChange, name }, label }) => {
  return (
    <FormGroup>
      {label && <Label>{label}</Label>}
      <InputGroup>
        <span className="color-selector">
          {availableColors.map((color) => (
            <label
              key={color}
              className={`${value === color ? 'checked' : ''}`}
            >
              <span className={`color-item bg-${color}`} />
              <input
                name={name}
                type="radio"
                value={color}
                checked={value === color}
                onChange={onChange}
              />
            </label>
          ))}
        </span>
      </InputGroup>
    </FormGroup>
  );
};

export default FormColorSelector;
